import { useMemo } from "react";
import ArchivedUserActionsCell from "modules/users/ArchivedUserActionsCell/ArchivedUserActionsCell";
import UserRolesCell from "modules/users/UserRolesCell/UserRolesCell";
import usePaginatedResources from "hooks/usePaginatedResources";
import useGetOrganizationUsers from "./useGetOrganizationUsers";
import { usePaginatedVariables } from "hooks/strings/usePaginatedVariables";

export default function useArchivedOrganizationUsersTable() {
  const { filtering, offset } = usePaginatedVariables();
  const { data, loading, error, paginatorInfo } = useGetOrganizationUsers({
    page: offset.page,
    first: offset.first,
    search: filtering.debouncedSearchTerm,
    archived: true,
  });
  const pagination = usePaginatedResources({
    paginatorInfo,
    paginate: offset.paginate,
  });

  const columns = useMemo(() => {
    return [
      { Header: "First Name", accessor: "firstName", width: "20%" },
      { Header: "Last Name", accessor: "lastName", width: "20%" },
      { Header: "Email", accessor: "email" },
      { Header: "Roles", accessor: "roles", Cell: UserRolesCell },
      {
        Header: "Archived On",
        accessor: "archivedAt",
        Cell: (props: { value?: string | null }) =>
          props.value ? new Date(props.value).toLocaleDateString() : "",
      },
      {
        Header: "Actions",
        accessor: "id",
        Cell: ArchivedUserActionsCell,
        align: "right",
      },
    ];
  }, []);

  const tableData = useMemo(() => {
    return { columns, rows: data };
  }, [columns, data]);

  return {
    data,
    loading,
    error,
    columns,
    tableData,
    pagination,
    filtering,
    paginatorInfo,
  } as const;
}
